import { useRef, useEffect } from "react";

export default function useBnavFab(callback){
  const cbRef=useRef(callback);
  cbRef.current=callback;
  useEffect(()=>{
    const h=(e)=>cbRef.current(e.detail);
    window.addEventListener("bnav:fab",h);
    return()=>window.removeEventListener("bnav:fab",h);
  },[]);
}
